package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_MERCHANT_PROFILE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class UpdateMerchantProfileRequestModel(
    val merchantId: Long,
    val companyName: String? = null,
    val dialCode: String? = null,
    val phoneNumber: String? = null,
    val bulstat: String? = null,
    val iban: String? = null,
    val logoImageUrl: String? = null,
    val countryId: Int? = null,
    val cityId: Long? = null,
    val companyStreet: String? = null
) : BaseRequestModel(api = UPDATE_MERCHANT_PROFILE)
